import {
    CHECKBOX_COLUMN_WIDTH,
    DEFAULT_COLUMN_WIDTH,
    EXPAND_COLUMN_WIDTH,
    SIZELESS_FLEX_GROW,
} from '@components/Table/VirtualTable/constants';
import type { MadeColumnType } from '@components/Table/hooks/useMakeColumns';

interface Props {
    displayColumns: MadeColumnType[];
}

export const EmptyBodyPlaceholder = ({ displayColumns }: Props) => {
    return (
        <div className="virtual_table_placeholder_row">
            {displayColumns.map((col, i) => {
                const isExpandColumn = col.key === 'virtual-table-expand';
                const isCheckbox = col.key === 'virtual-table-checkbox';
                const cellWidth = isExpandColumn
                    ? (col.width ?? EXPAND_COLUMN_WIDTH)
                    : isCheckbox
                      ? CHECKBOX_COLUMN_WIDTH
                      : (col.width ?? DEFAULT_COLUMN_WIDTH);
                const flexGrow = isExpandColumn
                    ? (col.width ?? EXPAND_COLUMN_WIDTH)
                    : isCheckbox
                      ? CHECKBOX_COLUMN_WIDTH
                      : (col.width ?? SIZELESS_FLEX_GROW);

                return (
                    <div
                        key={`${col.key}${col.title}${i}`}
                        style={{
                            minWidth: cellWidth,
                            width: cellWidth,
                            flexGrow: flexGrow,
                            flexShrink: 0,
                        }}
                    />
                );
            })}
        </div>
    );
};
